<template>
  <div>
    <p>{{ title }}</p>
    <div class="custom-radio-wrapper">
      <input
        type="radio"
        :value="true"
        :id="`custom-radio-input-yes${title}`"
        v-model="isPicked"
      />
      <label :for="`custom-radio-input-yes${title}`" style="margin-right: 20px;"
        >Tak</label
      >
      <input
        type="radio"
        :value="false"
        :id="`custom-radio-input-no${title}`"
        v-model="isPicked"
      />
      <label :for="`custom-radio-input-no${title}`">Nie</label>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "prePicked"],
  emits: ["picked"],
  data() {
    return {
      isPicked: this.prePicked || false,
    };
  },
  watch: {
    isPicked() {
      this.$emit("picked", this.isPicked);
    },
  },
};
</script>

<style scoped>
p {
  color: #090741;
  font-size: 14px;
  font-weight: 500;
}
.custom-radio-wrapper {
  display: flex;
  align-items: center;
  padding: 0;
  font-size: 14px;
  gap: 5px;
  font-weight: 500;
  color: #090741;
}
input[type="radio"] {
  accent-color: #ec1a6b;
}
label {
  padding: 0;
  margin: 0;
}
</style>
